module.exports = __webpack_public_path__ + "img/fairness-tip.9ffdc773.webp";